import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function TestimonialsSection() {
  const { t } = useTranslation('common');
  
  const testimonials = [
    {
      id: 1,
      rating: 5,
      title: t('testimonials.client1Title'),
      text: t('testimonials.client1Text'),
      author: t('testimonials.client1'),
      position: t('testimonials.client1Title')
    },
    {
      id: 2,
      rating: 5,
      title: t('testimonials.client2Title'),
      text: t('testimonials.client2Text'),
      author: t('testimonials.client2'),
      position: t('testimonials.client2Title')
    },
    {
      id: 3,
      rating: 5,
      title: t('testimonials.client3Title'),
      text: t('testimonials.client3Text'),
      author: t('testimonials.client3'),
      position: t('testimonials.client3Title')
    },
    {
      id: 4,
      rating: 5,
      title: t('testimonials.client4Title'),
      text: t('testimonials.client4Text'),
      author: t('testimonials.client4'),
      position: t('testimonials.client4Title')
    },
    {
      id: 5,
      rating: 5,
      title: t('testimonials.client5Title'),
      text: t('testimonials.client5Text'),
      author: t('testimonials.client5'),
      position: t('testimonials.client5Title')
    },
    {
      id: 6,
      rating: 5,
      title: t('testimonials.client6Title'),
      text: t('testimonials.client6Text'),
      author: t('testimonials.client6'),
      position: t('testimonials.client6Title')
    }
  ];

  return (
    <section className="py-32 bg-[#F8F6F3]">
      <div className="max-w-[1440px] mx-auto px-8 lg:px-16">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-2 h-2 bg-gray-900 rounded-full"></div>
            <p className="text-sm text-gray-600 font-light tracking-wider">{t('testimonials.subtitle')}</p>
          </div>
          <h2 className="text-5xl md:text-7xl font-bold text-gray-900 leading-tight">
            {t('testimonials.title')}
          </h2>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-xl font-medium text-gray-900 mb-4">
                {testimonial.title}
              </h3>

              {/* Review Text */}
              <p className="text-gray-600 text-base leading-relaxed mb-8" style={{ lineHeight: '1.7' }}>
                {testimonial.text}
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-gray-200 to-gray-300 rounded-full flex items-center justify-center">
                  <span className="text-gray-600 font-semibold text-lg">
                    {testimonial.author.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-base font-bold text-gray-900">{testimonial.author}</p>
                  <p className="text-sm text-gray-500">{testimonial.position}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
